export const iconFontAwesomePoliticalAward = (
	<i className="fa-solid fa-award"></i>
);
